import styled from 'styled-components'
import { DefaultFontStyle } from '../../../styles/global-styles'

export const BookingTitle = styled.span`
  ${DefaultFontStyle};
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  display: flex;
  color: #0b0a0a;
  margin: 0px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 18px;
    line-height: 27px;
  }
`

export const BookingDate = styled.span`
  ${DefaultFontStyle};
  font-weight: 400;
  display: flex;
  font-size: 13px;
  line-height: 21px;
  color: ${props => props.theme.colours.black};
  margin: 0px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 16px;
    line-height: 24px;
  }
`

const ColumnBookingLayout = `
  gap: 5px;
  ${BookingTitle} {
    font-size: 18px;
  }
  ${BookingDate} {
    font-size: 16px;
  }
`

export const BookingDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 15px;
  &.popup {
    ${ColumnBookingLayout}
  }
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    ${ColumnBookingLayout}
  }
`

export const DetailsWrapper = styled.div`
  align-items: center;
  flex-direction: column;
`
